import React from 'react';
import { Eye, Edit2, X } from 'lucide-react';

const Table = ({ 
  columns, 
  data, 
  onRowClick, 
  onView,
  onEdit, 
  onDelete,
  canEdit,
  canDelete,
  customActions,
  rowClassName,
  actions = true 
}) => {
  const hasActions = actions && (onView || onEdit || onDelete || customActions);

  return (
    <div className="overflow-x-auto -mx-4 sm:mx-0">
      <div className="inline-block min-w-full align-middle">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-800">
            <tr>
              {columns.map((column, index) => (
                <th
                  key={index}
                  className="px-3 sm:px-4 py-3 text-left text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider whitespace-nowrap"
                >
                  {column.header}
                </th>
              ))}
              {hasActions && (
                <th className="px-3 sm:px-4 py-3 text-right text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider whitespace-nowrap">
                  İşlemler
                </th>
              )}
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            {data.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                className={`hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors group ${rowClassName ? rowClassName(row) : ''}`}
              >
                {columns.map((column, colIndex) => (
                  <td 
                    key={colIndex} 
                    className="px-3 sm:px-4 py-3 text-xs sm:text-sm text-gray-900 dark:text-gray-100 whitespace-nowrap"
                    onClick={() => !hasActions && onRowClick && onRowClick(row)}
                    style={{ cursor: !hasActions && onRowClick ? 'pointer' : 'default' }}
                  >
                    {column.render ? column.render(row) : row[column.accessor]}
                  </td>
                ))}
                {hasActions && (
                  <td className="px-3 sm:px-4 py-3 text-sm text-right whitespace-nowrap">
                    <div className="flex items-center justify-end gap-1 sm:gap-2">
                      {customActions && customActions(row)}
                      {onView && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onView(row);
                          }}
                          className="p-1.5 sm:p-2 text-blue-600 dark:text-blue-400 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-lg transition-all hover:scale-110"
                          title="Detay"
                        >
                          <Eye size={14} className="sm:w-4 sm:h-4" />
                        </button>
                      )}
                      {onEdit && (!canEdit || canEdit(row)) && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onEdit(row);
                          }}
                          className="p-1.5 sm:p-2 text-green-600 dark:text-green-400 hover:bg-green-50 dark:hover:bg-green-900/30 rounded-lg transition-all hover:scale-110"
                          title="Düzenle"
                        >
                          <Edit2 size={14} className="sm:w-4 sm:h-4" />
                        </button>
                      )}
                      {onDelete && (!canDelete || canDelete(row)) && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onDelete(row);
                          }}
                          className="p-1.5 sm:p-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/30 rounded-lg transition-all hover:scale-110"
                          title="Sil"
                        >
                          <X size={14} className="sm:w-4 sm:h-4" />
                        </button>
                      )}
                    </div>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {data.length === 0 && (
        <div className="text-center py-12 text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-800">
          <p className="text-sm">Veri bulunamadı</p>
        </div>
      )}
    </div>
  );
};

export default Table;
